export const usp = "uz6h8qm";
export const content = "chw4j5q";
export const text = "ts20bku";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");